import React from 'react';
import './sone-taran-karj.css';

const SoneTaranKarj = () => {
  return (

    <div className="goldloan-container">
    <div className="banner">
      <img src="/images/slider1.jpg" alt="Banner" className="banner" />
    </div>

      <h1>सोने तारण कर्ज</h1>
      <p>
        सोनं ही तुमचं कर्जही तुमचं. पैशाची गरज ही कधी सांगून येत नसते पण अशा अचानक ओढवलेल्या अडचणीत पैशाच सोंग 
        आणता येत. श्री वरद विनायकमध्ये सोने तारण ठेवा आणि कर्ज मिळवा कमी व्याजदरात व नाममात्र प्रोसेसिंग फी सोबत कारण 
        आम्ही ओळखतो तुमची गरज.
      </p>

    <h1>आवश्यक कागदपत्रे : </h1>
      <div className="gold-column">
        <ul>
          <li>मालमत्तेचा सर्च रिपोर्ट</li>
          <li>मालमत्तेचा मूल्यांकन रिपोर्ट</li>
          <li>500 रुपये चे दोन स्टॅम्प पेपर</li>
          <li>मालमत्तेचे गहान खत (मोर्गेज)</li>
          <li>इतर संस्थेची (NOC)</li>
          <li>15 चेक</li>
          <li>दोन जामीनदार व त्यांचे आधार कार्ड (झेरॉक्स)</li>
        </ul>
      </div>
      {/* <div className="gold-column">
        <ul>
          <li>इतर संस्थेची (NOC)</li>
          <li>15 चेक</li>
          <li>दोन जामीनदार व त्यांचे आधार कार्ड (झेरॉक्स)</li>
        </ul>
      </div> */}
    </div>

  );
};

export default SoneTaranKarj;
